import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AppStatus() {
  const { user, loading } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    let mounted = true;
    api.get("/health", { timeout: 5000 })
      .then(() => mounted && setState("live"))
      .catch(() => mounted && setState("offline"));
    return () => { mounted = false; };
  }, []);

  const apiLabel = state === "live" ? "API live" : state === "offline" ? "API offline" : "Checking API";
  const accountLabel = loading ? "Checking session" : user ? "Personal library on" : "Guest mode";

  return (
    <section className="relative z-50 border-b border-white/5 bg-[#03050a]/90 text-slate-100 backdrop-blur-xl">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-8 py-2.5 flex flex-wrap items-center justify-between gap-2 text-[10px] sm:text-xs font-mono uppercase tracking-[0.18em]">
        <div className="flex flex-wrap items-center gap-2 sm:gap-3">
          <StatusDot state={state} />
          <span className={state === "offline" ? "text-red-300" : "text-slate-100"}>{apiLabel}</span>
          <span className="hidden sm:inline text-slate-500">/</span>
          <span className="text-cyan-100/90">NeurAlpha ready</span>
        </div>
        <div className="flex items-center gap-2 text-slate-200/80">
          <span className="w-2 h-2 bg-[#ff4d1d] rounded-full shadow-[0_0_16px_rgba(255,77,29,.75)]" aria-hidden />
          <span>{accountLabel}</span>
        </div>
      </div>
    </section>
  );
}

function StatusDot({ state }) {
  const cls = state === "live"
    ? "bg-emerald-400 shadow-[0_0_16px_rgba(52,211,153,.82)]"
    : state === "offline"
      ? "bg-red-400 shadow-[0_0_16px_rgba(248,113,113,.82)]"
      : "bg-amber-300 animate-pulse shadow-[0_0_16px_rgba(252,211,77,.82)]";
  return <span aria-hidden className={`w-2.5 h-2.5 rounded-full ${cls}`} />;
}
